import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { TaskStatus } from 'app/console-api';
import { TasksStatusesMeta } from 'app/components/common/tasks-statuses/tasks-statuses';
import { AppsFiltersStyles } from 'app/components/common/common-styles';
import Select from 'react-select';

export const TaskStatusAdapter: FilterAdapter<TaskStatus> = {
  key: 'task_status',
  fromUrl: (sp) => {
    const raw = sp.get('task_status');
    if (raw && Object.values(TaskStatus).includes(raw as TaskStatus)) {
      return raw as TaskStatus;
    }
    return null;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('task_status');
    } else {
      next.set('task_status', value);
    }
    return next;
  },
  toKey: (v) => `task_status:${v || 'all'}`
};

export const TaskStatusFilter = () => {
  const ctl = useUrlFilterController();
  const value = ctl.get(TaskStatusAdapter);
  const options = Object.values(TaskStatus).map((status) => ({
    value: status,
    label: TasksStatusesMeta[status].title
  }));
  const selected = options.find((o) => o.value === value) ?? null;
  return (
    <Select
      isClearable
      isSearchable={false}
      styles={AppsFiltersStyles()}
      options={options}
      value={selected}
      placeholder="All statuses"
      onChange={(opt: any) => ctl.set(TaskStatusAdapter, opt?.value ?? null)}
    />
  );
};
